import { v4 as uuidV4 } from 'uuid';
import { createServiceBuilder } from "./lib";
import { injectedProjectSlice } from "./reducer";
const getResourceByID = (state, id) => {
    const serialized = state.projectData.project.resources[id];
    if (!serialized)
        return undefined;
    const type = selectors.getResourceTypeByID(state, serialized.typeID);
    return { ...serialized, type: type };
};
const { actions, selectors } = injectedProjectSlice;
export const ProjectServiceBuilder = createServiceBuilder({
    name: 'ProjectService',
    api: () => ({
        actions,
        selectors,
        createNewResource: (resourceType) => (dispatch, getState) => {
            const id = uuidV4();
            dispatch(actions._createNewResource({ id, resourceType }));
            return getResourceByID(getState(), id);
        },
        // getAllResources: createSelector(
        //   (state: HexelateState) => state.projectData.project.resources,
        //   selectors.getResourceTypes,
        //   (resourceMap): Resource[] => {
        //     Object.values(resourceMap).map(getResourceByID())
        //   },
        // ),
        getResourceByID,
        applySnapshot: (snapshot) => (dispatch, getState) => {
            (snapshot.resourceState)
                ? dispatch(actions.updateResource(snapshot.resourceState))
                : dispatch(actions.deleteResource(snapshot.resourceID));
            return getResourceByID(getState(), snapshot.resourceID);
        },
    }),
});
//# sourceMappingURL=ProjectService.js.map